module.exports = __webpack_public_path__ + "static/img/2.9cc8df1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/articles/200204/2.png
// module id = GUJ9
// module chunks = 1